<template lang="pug">
  main.app
    Navigation
    router-view.view
</template>

<script>
  import Navigation from '@/components/Navigation'

  export default {
    components: {
      Navigation,
    },

    mounted () {
      window.addEventListener('beforeinstallprompt', event => event.preventDefault())
      // disable install prompt on mobile
    },
  }
</script>

<style lang="sass">
  @import '@/assets/sass/global'
</style>

<style lang="sass" scoped>
  main.app
    display: flex
    min-height: 100vh

    .view
      flex-grow: 1
</style>